import { render, staticRenderFns } from "./MessengerService.vue?vue&type=template&id=4d42f134&scoped=true&"
import script from "./MessengerService.vue?vue&type=script&lang=js&"
export * from "./MessengerService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d42f134",
  null
  
)

export default component.exports